var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCarIcon = function SvgCarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M41.608 36.138a6.002 6.002 0 0 1-11.216 0l-.072-.201.022.064H17.658l-.05.137a6.002 6.002 0 0 1-11.288-.201l.022.064L2 36V22h6v-8.25c0-.966.895-1.75 2-1.75h24.302l4.07 10H46v14h-4.342zM12 32a2 2 0 1 0 0 4 2 2 0 0 0 0-4m24 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4.52-16H12v5.867l22.316.099zM6.392 31.862a6.002 6.002 0 0 1 11.216 0l.05.138h12.683l-.021.063.072-.201a6.002 6.002 0 0 1 11.288.201L41.66 32H42v-6H6v6h.341z"
  }))));
};
export default SvgCarIcon;